module.exports = __webpack_public_path__ + "static/media/included5.83772a6a.svg";